class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('.modal__close-button')?.addEventListener('click', this.close.bind(this));
    this.header = document.querySelector('.pxg-header');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  getWidth() {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = document.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    const width = this.getWidth();
    document.body.style.setProperty('padding-right', `${Number.parseFloat(width)}px`);
    this.header.style.setProperty('padding-right', `${Number.parseFloat(width)}px`);
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    window.requestAnimationFrame(() => {
      event.target.closest('details').setAttribute('open', true);
    });
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    setTimeout(() => {
      trapFocus(
        this.detailsContainer.querySelector('[tabindex="-1"]'),
        this.detailsContainer.querySelector('input:not([type="hidden"])'),
      );
    }, 250);
  }

  close(focusToggle = true) {
    document.body.style.removeProperty('padding-right');
    this.header.style.removeProperty('padding-right');
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
